import { render } from "./AdminViewCampaign.vue?vue&type=template&id=7fc05e47"
import script from "./AdminViewCampaign.vue?vue&type=script&lang=js"
export * from "./AdminViewCampaign.vue?vue&type=script&lang=js"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__